import { render, staticRenderFns } from "./interact-detail.vue?vue&type=template&id=0d04700b&"
import script from "./interact-detail.vue?vue&type=script&lang=js&"
export * from "./interact-detail.vue?vue&type=script&lang=js&"
import style0 from "./interact-detail.vue?vue&type=style&index=0&id=0d04700b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports